// extracted by mini-css-extract-plugin
export default {"stepsContainer":"styles_stepsContainer__oXDdE","buttonContainer":"styles_buttonContainer__Ao2Es"};